import { translate } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import EnhancedModal from "../../../../components/enhanced-modal";
import React,{ Fragment, useEffect } from 'react';
import { GUTTER_MD, MODAL_WIDTH_MD, SPAN_ONE_THIRD, SPAN_TWO_THIRDS } from "../../../../styles/constants";
import { MDMDATABASE, MSSQLSERVER, MYSQL, ORACLE, hideConnectionModal, hideDetailDdbConnection, saveDdbConnection, testDdbConnection } from "../action";
import { Button, Form, Row, Input, Col, Card, Select, Modal, Tooltip } from "antd";
import { changeConnectionForm } from "./actions";
import FormDbTypeMDM from "./forms/FormDbTypeMDM";
import FormDbTypeMSSQL from "./forms/FormDbTypeMSSQL";
import FormDbTypeORACLE from "./forms/FormDbTypeORACLE";
import FormDbTypeMYSQL from "./forms/FormDbTypeMYSQL";
import { convertConnectionType, convertDbType } from "../List";
import { isFieldValid } from "./validateUtils";

const mapStateToProps = state => ({
    showModalConnection: state.scenes.mappingHandler.ddbConnection.shared.showModalConnection,
    connections: state.scenes.mappingHandler.ddbConnection.shared.connections,
    connectionDetail: state.scenes.mappingHandler.ddbConnection.shared.connectionDetail,
    creating: state.scenes.mappingHandler.ddbConnection.shared.creating,
    connectionTestPassed: state.scenes.mappingHandler.ddbConnection.shared.connectionTestPassed,
})

const mapDispatchToProps = dispatch => ({
    onHideModalConnection: () => dispatch(hideConnectionModal()),
    onChange: fields => dispatch(changeConnectionForm(fields)),
    onHideDetailDdbConnection: () => dispatch(hideDetailDdbConnection()),
    onSaveNewConnection: (data) => dispatch(saveDdbConnection(data)),
    onTestConnection: (connection) => dispatch(testDdbConnection(connection)),
})

const mapPropsToFields = ({
    connectionDetail
}) => ({
    connectionName:Form.createFormField({value: !!connectionDetail ? connectionDetail.connectionName : null }),
    dbType:Form.createFormField({value:!!connectionDetail ? connectionDetail.dbType : null }),
    dbName:Form.createFormField({value: !!connectionDetail ? connectionDetail.dbName: null }),
    connection:Form.createFormField({value: !!connectionDetail ? connectionDetail.connection: null }),
    server:Form.createFormField({value: !!connectionDetail ? connectionDetail.server : null }),
    database:Form.createFormField({value:  connectionDetail ?  connectionDetail.database: null }),
    port:Form.createFormField({value: !!connectionDetail ? connectionDetail.port : null }),
    userId:Form.createFormField({value: !!connectionDetail ? connectionDetail.userId : null }),
    password:Form.createFormField({value: !!connectionDetail ? connectionDetail.password : null }),
    dataSource:Form.createFormField({value: !!connectionDetail ? connectionDetail.dataSource : null }),
    integratedSecurity: Form.createFormField({value: !!connectionDetail ? connectionDetail.integratedSecurity : false }),
    connectionType: Form.createFormField({value: !!connectionDetail ? connectionDetail.connectionType : 2 }),
    oracleConfigurationFile: Form.createFormField({value:  !! connectionDetail ? connectionDetail.oracleConfigurationFile : null }),
    realDbType: Form.createFormField({value:  !! connectionDetail ? connectionDetail.realDbType : null }),
    sid: Form.createFormField({value:  !! connectionDetail ? connectionDetail.sid : null }),
    nodeId:Form.createFormField({value:  connectionDetail ?  connectionDetail.nodeId: null }),
})

export const formItemLayout = {
    labelCol: {span: SPAN_ONE_THIRD},
    wrapperCol: {span: SPAN_TWO_THIRDS}
};

const dbTypeArray = [
    {
        label: MDMDATABASE,
        value: 1
    },
    {
        label: MSSQLSERVER,
        value: 2
    },
    {
        label: ORACLE,
        value: 3
    },
    {
        label: MYSQL,
        value: 4
    }
]

const onFieldsChange = (props, fields) => {
    props.onChange(fields);
}

const ConnectionControl = ({
    t,
    form,
    connectionDetail,
    showModalConnection,
    onHideModalConnection,
    onHideDetailDdbConnection,
    onSaveNewConnection,
    onTestConnection,
    creating,
    connectionTestPassed
}) => {

    useEffect(()=>{
        return () => {
            onHideDetailDdbConnection()
            form.resetFields()
        }
    },[])

    useEffect(() => {
        if(!!connectionTestPassed) {
            Modal.success({
                title:t('scenes.mappingHandler.DDBConnection.messages.success.test')
            })
        }
    }, [connectionTestPassed])

    const handleCloseModal = () => {
        !!connectionDetail ? onHideDetailDdbConnection() : 
        onHideModalConnection();
        form.resetFields();
    } 

    useEffect(()=>{
        if(form.getFieldValue('integratedSecurity')){
            form.setFieldsValue({'password': null, 'userId': null})
        }
    },[form.getFieldValue('integratedSecurity')])

    const handleSaveConnection = () => {
        onSaveNewConnection({
            connectionName: form.getFieldValue('connectionName'),
            dbType: form.getFieldValue('dbType'),
            dbTypeDescription: convertDbType(form.getFieldValue('dbType')),
            connection: form.getFieldValue('connection') ? form.getFieldValue('connection') : '',
            server: form.getFieldValue('server') ? form.getFieldValue('server') : '',
            database: form.getFieldValue('database') ? form.getFieldValue('database') : '',
            port: form.getFieldValue('port') ? form.getFieldValue('port') : 0,
            userId: form.getFieldValue('userId') ? form.getFieldValue('userId') : '',
            password: form.getFieldValue('password') ? form.getFieldValue('password') : '',
            dataSource: form.getFieldValue('dataSource') ? form.getFieldValue('dataSource') : '',
            connectionType: form.getFieldValue('connectionType') ? form.getFieldValue('connectionType') : 0,
            connectionTypeDescription: form.getFieldValue('connectionType') ? convertConnectionType(form.getFieldValue('connectionType')) : '',
            oracleConfigurationFile: form.getFieldValue('oracleConfigurationFile') ? form.getFieldValue('oracleConfigurationFile') : '',
            integratedSecurity: form.getFieldValue('integratedSecurity') ? form.getFieldValue('integratedSecurity') : false,
            entityId: !!connectionDetail.entityId ? connectionDetail.entityId : '',
            realDbType: form.getFieldValue('realDbType') ? form.getFieldValue('realDbType') : 0,
            sid: form.getFieldValue('sid') ? form.getFieldValue('sid') : "",
            nodeId: form.getFieldValue('nodeId') ? form.getFieldValue('nodeId') : '',
        })
    }

    const handleTestConnection = () => {
        onTestConnection({
            connectionName: connectionDetail.connectionName,
            dbType: connectionDetail.dbType,
            dbTypeDescription: convertDbType(connectionDetail.dbType),
            connection: !!connectionDetail.connection ? connectionDetail.connection : '',
            server: !!connectionDetail.server ? connectionDetail.server : '',
            database: !!connectionDetail.database ? connectionDetail.database : '',
            port: !!connectionDetail.port ? connectionDetail.port : 0,
            userId: !!connectionDetail.userId? connectionDetail.userId: '',
            password: !!connectionDetail.password ? connectionDetail.password : '',
            dataSource: !!connectionDetail.dataSource ? connectionDetail.dataSource : '',
            connectionType: !!connectionDetail.connectionType ? connectionDetail.connectionType : 0,
            connectionTypeDescription: !!connectionDetail.connectionType ? convertConnectionType(connectionDetail.connectionType) : '',
            oracleConfigurationFile: !!connectionDetail.oracleConfigurationFile ? connectionDetail.oracleConfigurationFile : '',
            integratedSecurity: !!connectionDetail.integratedSecurity ? connectionDetail.integratedSecurity : false,
            entityId: !!connectionDetail.entityId ? connectionDetail.entityId : '',
            realDbType: !!connectionDetail.realDbType ? connectionDetail.realDbType : 0,
            sid: !!connectionDetail.sid ? connectionDetail.sid : '',
            nodeId: !!connectionDetail.nodeId ? connectionDetail.nodeId : '',
        })
    }

    function isFormValid() {
        if(!!connectionDetail) {
          if( !isFieldValid(t, connectionDetail.connectionName).valid || 
              !isFieldValid(t, connectionDetail.dbType).valid) {
            return false;
          }
          if(connectionDetail.dbType === 1) {
            if( !isFieldValid(t, connectionDetail.connection).valid ||
                !isFieldValid(t, connectionDetail.realDbType).valid || 
                !isFieldValid(t, connectionDetail.nodeId).valid) {
                return false;
            }
          }
          if(connectionDetail.dbType === 2 || connectionDetail.dbType === 4) {
            if( !isFieldValid(t, connectionDetail.server).valid || 
                !isFieldValid(t, connectionDetail.database).valid) {
                return false;
            }
          }
          if( (connectionDetail.dbType === 2 && !connectionDetail.integratedSecurity) || connectionDetail.dbType === 4 || 
              (connectionDetail.dbType === 3 && connectionDetail.connectionType === 2)) {
              if( !isFieldValid(t, connectionDetail.userId).valid || 
                  !isFieldValid(t, connectionDetail.password).valid) {
                  return false;
              }
          }
          if(connectionDetail.dbType === 3) {
            // if(!isFieldValid(t, connectionDetail.connectionType).valid) {
            //     return false;
            // } 
            // if(!isFieldValid(t, connectionDetail.dataSource).valid) {
            //     return false;
            // }
            if( !isFieldValid(t, connectionDetail.userId).valid 
                || !isFieldValid(t, connectionDetail.password).valid 
                || !isFieldValid(t, connectionDetail.sid).valid) {
                  return false;
              }
            if(connectionDetail.connectionType === 1) {
                if(!isFieldValid(t, connectionDetail.oracleConfigurationFile).valid) {
                    return false;
                }
            }
            
          }
          return true;
        }
    }

    useEffect(()=>{
        return ()=> {
            form.resetFields()
        }
    },[])

    return (
        <Fragment>
           <EnhancedModal 
                title={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.title')}
                visible={showModalConnection}
                width={MODAL_WIDTH_MD}
                onCancel={handleCloseModal}
                footer={
                    <div>
                      <Button onClick={handleCloseModal}>{t('commons.buttons.close.title')}</Button>
                      <Button
                        type="primary"
                        onClick={handleSaveConnection}
                        disabled={!isFormValid()}
                      >
                        {t('commons.buttons.save.title')}
                      </Button>
                    </div>
                  }
                >
                        <Row type="flex" justify="center">
                            <Col style={{width: MODAL_WIDTH_MD}}>
                                <Card type="inner">
                                    <Form>
                                        <Row gutter={GUTTER_MD} >
                                            <Col>
                                                <Form.Item
                                                    label={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.connectionName')}
                                                    className="form-item-required"
                                                    {...formItemLayout}
                                                >       
                                                    {form.getFieldDecorator('connectionName', {
                                                    })(<Input 
                                                        style={{ width: "100%"}}
                                                        disabled={!creating}  
                                                    />)}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row gutter={GUTTER_MD} >
                                            <Col>
                                                <Form.Item 
                                                    label={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.dbType')}
                                                    className="form-item-required"
                                                    {...formItemLayout}
                                                >       
                                                    {form.getFieldDecorator('dbType', {
                                                    })(
                                                        <Select disabled={!creating} >
                                                            {
                                                                dbTypeArray.map((dbType) =>
                                                                <Select.Option key={dbType.value} 
                                                                    value={dbType.value} 
                                                                    title={dbType.label}>
                                                                    {dbType.label}
                                                                </Select.Option>
                                                                )
                                                            }
                                                        </Select>
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        { 
                                            // MDMDATABASE
                                            form.getFieldValue('dbType') === 1 && 
                                            <FormDbTypeMDM  form={form} connectionDetail={connectionDetail} /> 
                                        }
                                        {
                                            // MSSQLSERVER
                                            form.getFieldValue('dbType') === 2 &&
                                            <FormDbTypeMSSQL form={form} connectionDetail={connectionDetail} />
                                        }
                                        {
                                            // ORACLE
                                            form.getFieldValue('dbType') === 3 &&
                                            <FormDbTypeORACLE form={form} creating={creating} />
                                        }
                                        {
                                            // MYSQL
                                            form.getFieldValue('dbType') === 4 &&
                                            <FormDbTypeMYSQL form={form} connectionDetail={connectionDetail} />
                                        }
                                    </Form>
                                    
                                </Card>
                            </Col>
                        </Row>
                        <Row style={{marginTop:'10px'}}>
                            <Col>
                                <Tooltip
                                    title={t("scenes.mappingHandler.DDBConnection.tooltip.testConnection")}>
                                    <Button 
                                        type="primary" 
                                        disabled={!isFormValid()} 
                                        onClick={() => {
                                            handleTestConnection()
                                        }}
                                    >Test Connection</Button>
                                </Tooltip>
                            </Col>
                        </Row>
            </EnhancedModal>
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps,mapDispatchToProps),
    Form.create({
        mapPropsToFields, 
        onFieldsChange
    })
)(ConnectionControl)